// Mirrors PermissionUtils.matchesPermission (auth-module) exactly. UI-side only: a
// "can't tell" result here must never grant an action the server would refuse, but it
// is also never the final word -- the server re-checks on every request regardless.
export const matchesPermission = (granted, required) => {
    if (granted === "superadmin:*") return true;
    if (granted === required) return true;
    if (granted.endsWith(":*")) {
        const resource = granted.slice(0, -2);
        return required.startsWith(resource + ":");
    }
    return false;
};

const hasPermission = (grantedPermissions, required) =>
    grantedPermissions.some((granted) => matchesPermission(granted, required));

// Mirrors V4AuthorizationGraphService.requireUserAuthority's G2-G5 gates. Returns the
// list of missing "licenses" (role names the current user lacks role_<slug>:admin for),
// or [] if the row's View QR / Generate QR actions are allowed.
export const missingLicenses = (currentUser, row) => {
    const rowUid = row?.uid || row?.id;
    const isSelf = (currentUser?.uid && rowUid && currentUser.uid === rowUid)
        // login.js writes uid since 2026-09-09, but a session that signed in before that
        // still has a uid-less "user" object in localStorage until the next login --
        // fall back to username, which is always present, so G2 (self is always allowed)
        // still holds in practice instead of silently degrading to G4/G5 for one's own row.
        || (currentUser?.username && row?.username && currentUser.username === row.username);
    if (isSelf) return []; // G2

    const grantedPermissions = Array.isArray(currentUser?.permissions) ? currentUser.permissions : [];
    if (hasPermission(grantedPermissions, "superadmin:*")) return []; // G3

    // Old backend payload (no positions/auxiliaryRoles key yet): "don't know" must not
    // mean "disable" -- let the server keep deciding, same as before this brief.
    if (!Array.isArray(row?.positions)) return [];

    const positions = row.positions;
    if (positions.length === 0) {
        return hasPermission(grantedPermissions, "role_unassigned:admin") ? [] : ["ยังไม่มีตำแหน่ง"];
    }

    const missing = [];
    positions.forEach((position) => {
        if (!position.slug) {
            missing.push(position.name); // fail-closed: un-slugged position, same as server
            return;
        }
        if (!hasPermission(grantedPermissions, `role_${position.slug}:admin`)) {
            missing.push(position.name);
        }
    });
    return missing;
};
